import { useTranslation } from 'react-i18next';
import Typography from '@lib/components/Typography/Typography';
import styles from './AiAssistant.module.scss';

type Props = {
  suggestions: string[];
  disabled?: boolean;
  onSelect: (suggestion: string) => void;
};

function SuggestedFollowups({ suggestions, disabled, onSelect }: Props) {
  const { t } = useTranslation();
  if (!suggestions.length) return null;
  return (
    <div className={styles.suggestionsSection}>
      <Typography variant="caption" className={styles.suggestionsLabel}>
        {t('ai-suggested-next-steps')}
      </Typography>
      <div className={styles.suggestionsList}>
        {suggestions.map((suggestion, index) => (
          <button
            // suggestions are a static, non-reordered list; index disambiguates
            // any duplicate strings the BE may return
            // eslint-disable-next-line react/no-array-index-key
            key={`${suggestion}-${index}`}
            type="button"
            className={styles.suggestionPill}
            disabled={disabled}
            onClick={() => onSelect(suggestion)}
          >
            {suggestion}
          </button>
        ))}
      </div>
    </div>
  );
}

export default SuggestedFollowups;
